// The form the backend stores and compares by (`Cnpj.normalize` in frentista); it does not strip the mask itself.
// Digits-only would merge distinct alphanumeric CNPJs that share the same digits (IN RFB 2.229/2024).
export const normalizeCnpj = (value: string): string => value.replace(/[^0-9A-Za-z]/g, '').toUpperCase();
